module.exports = __webpack_public_path__ + "img/bcc123.76046a47.jpeg";